export class SMS {
    text: string;
    date: Date;
    local: string;
    remote: string;
    outgoing: boolean;
}
